import React from "react"
import Message from "~components/Message"
import Entry from "./Entry"
import Pagination from "./Pagination"
import * as style from "./Entries.module.scss"

const Entries = ({ engine, microcopy }) => {
  const entries = engine.page()

  return (
    <>
      <Pagination
        className={style.pagination}
        engine={engine}
        microcopy={microcopy}
      />
      <div className={style.entries}>
        <div>
          {entries.map((entry) => (
            <Entry
              key={entry.id}
              entry={entry}
              engine={engine}
              microcopy={microcopy}
            />
          ))}
          {!entries?.[0] && (
            <Message notice>
              {microcopy.text("changelog.messages.no_entries")}
            </Message>
          )}
        </div>
      </div>
      <Pagination
        className={style.pagination}
        engine={engine}
        microcopy={microcopy}
        align="right"
      />
    </>
  )
}

export default Entries
